import cn from 'classnames';

const DashedVerticalLine = ({ color }) => {
  return (
    <div className="flex flex-col items-center gap-1">
      {[0, 1, 2, 3].map(i => (
        <div
          key={i}
          className={cn(
            'w-[2px] rounded',
            i === 0 || i === 3 ? 'h-2' : 'h-4',
            color,
            i !== 0 && i !== 3 && 'my-0.5'
          )}
        />
      ))}
    </div>
  );
};

DashedVerticalLine.propTypes = {
  color: PropTypes.string.isRequired,
};

export default DashedVerticalLine;
